import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { reportComment } from '../utils/backend-api/comments';

export default function useCommentReport(id: number) {
  const { mutate, isLoading, isError } = useMutation(() => reportComment(id), {
    onSuccess: () => {
      toast.success('Your report was submitted');
    },
    onError: () => {
      toast.error('Report was not submitted, please try again');
    },
  });
  return { mutate, isLoading, isError };
}
